import React from 'react';
import PropTypes from 'prop-types';
import { WithContext as ReactTags } from 'react-tag-input';

import './KTTags.css';

const KeyCodes = {
  comma: 188,
  enter: 13
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

class KTTags extends React.Component {
  transformArrayIntoArrayOfObjects () {
    const { tags } = this.props;
    return tags.map((tag) => {
      return { id: tag, text: tag };
    });
  }

  transformArrayOfObjectsIntoArray (aoo) {
    return aoo.map((tagObject) => {
      return aoo.text;
    });
  }

  handleDelete (i) {
    const { tags } = this.props;
    this.props.onTagsChange(tags.filter((tag, index) => index !== i));
  }

  handleAddition (tag) {
    this.props.onTagsChange([...this.props.tags, tag.text]);
  }

  render () {
    return (
      <div>
        <ReactTags
          tags={this.transformArrayIntoArrayOfObjects()}
          handleDelete={(i) => this.handleDelete(i)}
          handleAddition={(tag) => this.handleAddition(tag)}
          delimiters={delimiters}
        />
      </div>
    );
  }
}

KTTags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
  onTagsChange: PropTypes.func
};

KTTags.defaultProps = {
  tags: null,
  onTagsChange: () => {}
};

export default KTTags;
